import styled from "styled-components";
import { getColor, getSize } from "~/helpers/style";
import { UIProps } from "~/types/style";

export const PageTitle = styled.h1`
  font-weight: 700;
  font-size: ${getSize(2.4)};
  line-height: ${getSize(2.4)};
  text-align: center;

  @media (max-width: 768px) {
    font-weight: 600;
    font-size: ${getSize(1.55)};
    line-height: ${getSize(1.25)};
    margin-bottom: ${getSize(0.875)};
  }
`;

interface IPlansGrid extends UIProps {
  gap: number;
}

export const PlansGrid = styled.div<IPlansGrid>`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ gap }) => getSize(gap)};
  margin: ${getSize(3.5)} auto ${getSize(2)} auto;
  justify-content: center;
  align-items: stretch;
  width: 100%;
`;

export const ToggleContentText = styled.p`
  margin: 0;
  font-size: ${getSize(1.3)};
  font-weight: 500;
  line-height: ${getSize(2.0)};
  color: ${getColor("textDisabled")};

  &.selected {
    font-weight: 500;
    color: ${getColor("text")};
  }
  
  @media (max-width: 768px) {
    font-size: ${getSize(1.4)};
  }
`;

export const PromotionText = styled.div`
  position: relative;
  background-color: ${getColor("greenSecondary")};
  color: ${getColor("green")};
  margin: 0;
  padding: ${getSize(0.2)};
  padding: ${getSize(0.2)} ${getSize(1)};
  border-radius: ${getSize(0.5)};
  font-size: ${getSize(1.2)};
  font-weight: 500;
  line-height: ${getSize(1.83)};
`;
export const YearlyWrapper = styled.div`
  position: relative;
  display: flex;
  gap: 5px;
`

export const Arrow = styled.span`
  position: absolute;
  top: -20px;
  right: 73%;
  transform: translateX(50%);

  @media (max-width: 768px) {
    display: none;
  }
`;

